import React, {
  useEffect,
  useState,
} from "react";

import {
  Link,
} from "react-router-dom";

/* =========================================================
   RULE NAVIGATION
========================================================= */

const sections = [
  {
    id: "overview",
    label: "Overview",
  },
  {
    id: "rule-1",
    label: "1. New-to-$KIND wallets",
  },
  {
    id: "rule-2",
    label: "2. Active campaign purchases",
  },
  {
    id: "rule-3",
    label: "3. Qualification starts",
  },
  {
    id: "rule-4",
    label: "4. Maximum $200",
  },
  {
    id: "rule-5",
    label: "5. Bonus tiers",
  },
  {
    id: "rule-6",
    label: "6. USD bonus calculation",
  },
  {
    id: "rule-7",
    label: "7. Four claims",
  },
  {
    id: "rule-8",
    label: "8. Reward pool",
  },
  {
    id: "rule-9",
    label: "9. Do not sell",
  },
  {
    id: "rule-10",
    label: "10. Do not send",
  },
  {
    id: "rule-11",
    label: "11. Do not receive",
  },
  {
    id: "rule-12",
    label: "12. Additional purchases",
  },
  {
    id: "rule-13",
    label: "13. Claim before end",
  },
  {
    id: "rule-14",
    label: "14. No carry forward",
  },
  {
    id: "rule-15",
    label: "15. Check dashboard",
  },
  {
    id: "avoid",
    label: "Avoid disqualification",
  },
  {
    id: "important",
    label: "Important",
  },
];

/* =========================================================
   PAGE
========================================================= */

export default function Rules() {
  const [
    activeSection,
    setActiveSection,
  ] = useState("overview");

  /* =======================================================
     TRACK CURRENT SECTION
  ======================================================= */

  useEffect(() => {
    const handleScroll = () => {
      let current =
        "overview";

      sections.forEach(
        (section) => {
          const element =
            document.getElementById(
              section.id
            );

          if (!element) {
            return;
          }

          const rect =
            element.getBoundingClientRect();

          if (
            rect.top <= 160
          ) {
            current =
              section.id;
          }
        }
      );

      setActiveSection(
        current
      );
    };

    window.addEventListener(
      "scroll",
      handleScroll,
      {
        passive: true,
      }
    );

    handleScroll();

    return () => {
      window.removeEventListener(
        "scroll",
        handleScroll
      );
    };
  }, []);

  /* =======================================================
     SCROLL
  ======================================================= */

  const goToSection = (
    id
  ) => {
    const element =
      document.getElementById(
        id
      );

    if (!element) {
      return;
    }

    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  /* =======================================================
     RENDER
  ======================================================= */

  return (
    <div className="min-h-screen bg-[#050609] text-white">

      <div className="mx-auto grid max-w-[1500px] grid-cols-1 lg:grid-cols-[250px_minmax(0,1fr)] xl:grid-cols-[270px_minmax(0,1fr)_210px]">

        {/* =================================================
            LEFT SIDEBAR
        ================================================= */}

        <aside className="hidden border-r border-white/[0.07] lg:block">

          <div className="rules-sidebar sticky top-[76px] max-h-[calc(100vh-76px)] overflow-y-auto px-5 py-8">

            <div className="mb-5">

              <div className="text-[9px] font-black uppercase tracking-[0.2em] text-[#ffcc66]">
                Documentation
              </div>

              <div className="mt-2 text-sm font-black text-white">
                Rules & Eligibility
              </div>

            </div>

            <nav className="space-y-1">

              {sections.map(
                (section) => {
                  const active =
                    activeSection ===
                    section.id;

                  return (
                    <button
                      key={
                        section.id
                      }
                      type="button"
                      onClick={() =>
                        goToSection(
                          section.id
                        )
                      }
                      className={`block w-full rounded-[8px] border-l-[3px] px-3 py-2.5 text-left text-[12px] font-semibold transition ${
                        active
                          ? "border-[#ffcc66] bg-[#ffcc66]/10 text-[#ffcc66]"
                          : "border-transparent text-[#777] hover:bg-white/[0.035] hover:text-white"
                      }`}
                    >
                      {
                        section.label
                      }
                    </button>
                  );
                }
              )}

            </nav>

          </div>

        </aside>

        {/* =================================================
            MAIN CONTENT
        ================================================= */}

        <main className="min-w-0 px-5 py-12 sm:px-8 lg:px-10 lg:py-14 xl:px-12">

          {/* ===============================================
              OVERVIEW
          =============================================== */}

          <section
            id="overview"
            className="scroll-mt-[110px]"
          >

            <div className="text-[10px] font-black uppercase tracking-[0.22em] text-[#ffcc66]">
              KIND BONUS RUSH
            </div>

            <h1 className="mt-3 text-4xl font-black uppercase tracking-[-0.035em] sm:text-5xl">
              Rules & Eligibility
            </h1>

            <p className="mt-6 max-w-[850px] text-[15px] leading-8 text-[#949494]">
              Before joining the Rush,
              please read these rules
              carefully.
            </p>

            <div className="mt-7 rounded-[12px] border border-red-500/20 bg-red-500/[0.04] p-5">

              <p className="text-sm font-bold leading-7 text-red-300">
                Breaking the holding or
                wallet rules can
                immediately disqualify
                your wallet and cancel
                any remaining bonus.
              </p>

            </div>

          </section>

          <Divider />

          {/* ===============================================
              RULE 1
          =============================================== */}

          <RuleSection
            id="rule-1"
            number="1"
            title="NEW-TO-$KIND WALLETS ONLY"
          >

            <p>
              KIND Bonus Rush is
              exclusively for wallets
              that have never previously
              interacted with $KIND.
            </p>

            <p>
              Your participating wallet
              must not have previously:
            </p>

            <BulletList
              items={[
                "Bought $KIND",
                "Held $KIND",
                "Received $KIND",
                "Otherwise interacted with $KIND",
              ]}
            />

            <p>
              Eligibility is checked
              against blockchain
              activity.
            </p>

          </RuleSection>

          <Divider />

          {/* ===============================================
              RULE 2
          =============================================== */}

          <RuleSection
            id="rule-2"
            number="2"
            title="ONLY PURCHASES DURING THE ACTIVE CAMPAIGN COUNT"
          >

            <p>
              Your qualifying $KIND
              purchases must happen
              after the active Bonus
              Rush begins.
            </p>

            <p>
              Previous purchases do
              not count.
            </p>

          </RuleSection>

          <Divider />

          {/* ===============================================
              RULE 3
          =============================================== */}

          <RuleSection
            id="rule-3"
            number="3"
            title="YOUR FIRST PURCHASE STARTS YOUR QUALIFICATION"
          >

            <p>
              Your first valid $KIND
              purchase starts your
              qualification countdown.
            </p>

            <p>
              You may make additional
              qualifying purchases
              during this period.
            </p>

            <p>
              Multiple valid purchases
              are added together up to
              the campaign's maximum
              qualifying purchase value.
            </p>

          </RuleSection>

          <Divider />

          {/* ===============================================
              RULE 4
          =============================================== */}

          <RuleSection
            id="rule-4"
            number="4"
            title="MAXIMUM QUALIFYING PURCHASE: $200"
          >

            <p>
              You may buy more than
              $200 of $KIND.
            </p>

            <p>
              However, only a maximum
              of $200 in qualifying
              purchases will be used
              to calculate your Bonus
              Rush reward.
            </p>

            <ExampleBox>

              <p>
                You purchase $300.
              </p>

              <p className="mt-2 font-bold text-[#ffcc66]">
                Qualifying amount =
                $200.
              </p>

            </ExampleBox>

          </RuleSection>

          <Divider />

          {/* ===============================================
              RULE 5
          =============================================== */}

          <RuleSection
            id="rule-5"
            number="5"
            title="BONUS TIERS"
          >

            <p>
              Your qualifying purchase
              determines the bonus tier
              you unlock.
            </p>

            <p>
              Available tiers:
            </p>

            <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">

              <TierBox
                value="100%"
              />

              <TierBox
                value="150%"
              />

              <TierBox
                value="200%"
              />

              <TierBox
                value="Up to 300%"
              />

            </div>

            <p>
              Your dashboard will
              display your applicable
              bonus.
            </p>

          </RuleSection>

          <Divider />

          {/* ===============================================
              RULE 6
          =============================================== */}

          <RuleSection
            id="rule-6"
            number="6"
            title="BONUS IS CALCULATED IN USD VALUE"
          >

            <p>
              Your bonus percentage
              applies to the recorded
              USD value of your
              qualifying $KIND
              purchases.
            </p>

            <ExampleBox>

              <p>
                Qualifying purchase:
                $100
              </p>

              <p className="mt-2">
                Bonus unlocked: 200%
              </p>

              <p className="mt-2 font-bold text-[#ffcc66]">
                Total potential
                bonus: $200.
              </p>

            </ExampleBox>

            <p>
              The reward is paid in
              $KIND based on the
              applicable KIND value
              when a claim is
              successfully processed.
            </p>

          </RuleSection>

          <Divider />

          {/* ===============================================
              RULE 7
          =============================================== */}

          <RuleSection
            id="rule-7"
            number="7"
            title="YOUR BONUS IS DIVIDED INTO 4 CLAIMS"
          >

            <ExampleBox>

              <p>
                Total potential bonus =
                $200
              </p>

              <p className="mt-3">
                Claim 1 = $50
              </p>

              <p>
                Claim 2 = $50
              </p>

              <p>
                Claim 3 = $50
              </p>

              <p>
                Claim 4 = $50
              </p>

            </ExampleBox>

            <p className="font-black uppercase text-[#ffcc66]">
              Maximum:
            </p>

            <p className="font-bold text-white">
              ONE successful claim
              every 24 hours.
            </p>

          </RuleSection>

          <Divider />

          {/* ===============================================
              RULE 8
          =============================================== */}

          <RuleSection
            id="rule-8"
            number="8"
            title="CLAIMS DEPEND ON AVAILABLE REWARD FUNDS"
          >

            <p>
              KIND Bonus Rush operates
              with a limited campaign
              reward pool.
            </p>

            <p>
              If sufficient funds are
              available when your
              eligible claim is
              processed, your reward
              is paid in $KIND.
            </p>

            <p>
              If sufficient funds are
              unavailable, the claim
              is not completed and
              your eligible amount
              remains pending while
              the campaign remains
              active.
            </p>

            <p>
              A failed claim due to
              insufficient pool funds
              does not count as one
              of your four successful
              claims.
            </p>

          </RuleSection>

          <Divider />

          {/* ===============================================
              RULE 9
          =============================================== */}

          <RuleSection
            id="rule-9"
            number="9"
            title="DO NOT SELL $KIND BEFORE COMPLETION"
            danger
          >

            <p className="font-black uppercase text-red-300">
              THIS IS VERY IMPORTANT.
            </p>

            <p>
              From your first
              qualifying purchase
              until you successfully
              complete all 4 claims:
            </p>

            <div className="rounded-[12px] border border-red-500/20 bg-red-500/[0.05] p-5">

              <div className="text-lg font-black uppercase text-red-300">
                DO NOT SELL ANY $KIND.
              </div>

            </div>

            <p>
              Selling ANY amount of
              $KIND immediately
              disqualifies the
              participating wallet.
            </p>

            <p>
              Your remaining unclaimed
              bonus will be cancelled.
            </p>

            <p>
              This includes selling
              $KIND previously
              received as a Bonus
              Rush reward before
              completing 4/4 claims.
            </p>

          </RuleSection>

          <Divider />

          {/* ===============================================
              RULE 10
          =============================================== */}

          <RuleSection
            id="rule-10"
            number="10"
            title="DO NOT SEND $KIND OUT"
            danger
          >

            <p>
              Do not transfer or send
              $KIND from your
              participating wallet
              before completing all
              four claims.
            </p>

            <p>
              Doing so disqualifies
              the wallet and cancels
              the remaining bonus.
            </p>

          </RuleSection>

          <Divider />

          {/* ===============================================
              RULE 11
          =============================================== */}

          <RuleSection
            id="rule-11"
            number="11"
            title="DO NOT RECEIVE $KIND FROM ANOTHER WALLET"
            danger
          >

            <p>
              Do not send $KIND from
              another wallet into
              your participating
              Bonus Rush wallet.
            </p>

            <p>
              Unauthorized incoming
              $KIND can result in
              disqualification.
            </p>

            <p>
              The following remain
              permitted:
            </p>

            <BulletList
              items={[
                "Valid $KIND purchases through approved routes",
                "Official $KIND rewards received from the Bonus Rush system",
              ]}
            />

          </RuleSection>

          <Divider />

          {/* ===============================================
              RULE 12
          =============================================== */}

          <RuleSection
            id="rule-12"
            number="12"
            title="ADDITIONAL PURCHASES ARE ALLOWED"
          >

            <p>
              You may continue buying
              $KIND.
            </p>

            <p>
              Additional valid
              purchases are allowed.
            </p>

            <p>
              However, once the
              maximum qualifying
              purchase value has
              been reached,
              additional purchases
              do not increase your
              Bonus Rush calculation.
            </p>

          </RuleSection>

          <Divider />

          {/* ===============================================
              RULE 13
          =============================================== */}

          <RuleSection
            id="rule-13"
            number="13"
            title="COMPLETE YOUR CLAIMS BEFORE THE RUSH ENDS"
          >

            <p>
              Potential bonuses are
              available only while
              the applicable Bonus
              Rush campaign remains
              active.
            </p>

            <p>
              When the campaign
              officially closes:
            </p>

            <BulletList
              items={[
                "No additional claims can be completed",
                "Pending claims expire",
                "Unclaimed bonus amounts expire",
                "Remaining potential bonus becomes void",
              ]}
            />

            <p>
              Rewards already
              successfully paid to
              your wallet remain
              yours.
            </p>

          </RuleSection>

          <Divider />

          {/* ===============================================
              RULE 14
          =============================================== */}

          <RuleSection
            id="rule-14"
            number="14"
            title="UNCLAIMED BONUSES DO NOT CARRY FORWARD"
          >

            <p>
              Every Bonus Rush
              campaign is independent.
            </p>

            <p>
              Unused, pending or
              unclaimed bonuses from
              one campaign do NOT
              move into the next
              Bonus Rush.
            </p>

            <p>
              A future campaign may
              operate under different
              rules.
            </p>

          </RuleSection>

          <Divider />

          {/* ===============================================
              RULE 15
          =============================================== */}

          <RuleSection
            id="rule-15"
            number="15"
            title="CHECK YOUR DASHBOARD"
          >

            <p>
              Your dashboard is where
              you can monitor:
            </p>

            <BulletList
              items={[
                "Qualification status",
                "Qualifying purchase",
                "Bonus tier",
                "Potential bonus",
                "Successful claims",
                "Remaining potential bonus",
                "24-hour claim timer",
                "Campaign status",
              ]}
            />

            <p>
              Always check your
              dashboard before taking
              an action that could
              affect your eligibility.
            </p>

          </RuleSection>

          <Divider />

          {/* ===============================================
              AVOID DISQUALIFICATION
          =============================================== */}

          <section
            id="avoid"
            className="scroll-mt-[110px] py-5"
          >

            <div className="text-[10px] font-black uppercase tracking-[0.2em] text-[#ffcc66]">
              STAY ELIGIBLE
            </div>

            <h2 className="mt-3 text-2xl font-black uppercase sm:text-3xl">
              Avoid Disqualification
            </h2>

            <p className="mt-5 text-[15px] leading-8 text-[#999]">
              Remember these four
              rules:
            </p>

            <div className="mt-6 grid gap-3 sm:grid-cols-2">

              <StatusBox
                good
                text="BUY ✓"
              />

              <StatusBox
                good
                text="HOLD ✓"
              />

              <StatusBox
                good
                text="CLAIM ✓"
              />

              <StatusBox
                text="SELL / SEND / UNAUTHORIZED RECEIVE BEFORE COMPLETION ✕"
              />

            </div>

            <p className="mt-7 font-black uppercase tracking-[0.07em] text-white">
              Complete 4/4 claims
              before moving your
              $KIND.
            </p>

          </section>

          <Divider />

          {/* ===============================================
              IMPORTANT
          =============================================== */}

          <section
            id="important"
            className="scroll-mt-[110px] py-5"
          >

            <div className="rounded-[16px] border border-[#ffcc66]/20 bg-[#ffcc66]/[0.04] p-6 sm:p-8">

              <div className="text-[10px] font-black uppercase tracking-[0.2em] text-[#ffcc66]">
                IMPORTANT
              </div>

              <div className="mt-5 space-y-4 text-[15px] leading-8 text-[#999]">

                <p>
                  KIND Bonus Rush is
                  a promotional reward
                  campaign.
                </p>

                <p>
                  Bonus percentages
                  refer to campaign
                  bonus calculations
                  and are not promises
                  of investment profit
                  or token-price
                  appreciation.
                </p>

                <p>
                  Potential and
                  pending rewards are
                  not guaranteed
                  payouts and remain
                  subject to wallet
                  eligibility,
                  campaign rules,
                  available reward
                  funds and the active
                  campaign period.
                </p>

                <p className="font-semibold text-white">
                  By participating,
                  you agree to the
                  applicable KIND
                  Bonus Rush campaign
                  rules.
                </p>

              </div>

              <div className="mt-7 flex flex-col gap-3 sm:flex-row">

                <Link
                  to="/dashboard"
                  className="inline-flex min-h-[50px] items-center justify-center rounded-[9px] bg-[#ffcc66] px-7 text-[10px] font-black uppercase tracking-[0.14em] text-black transition hover:brightness-110"
                >
                  Join The Rush
                </Link>

                <Link
                  to="/"
                  className="inline-flex min-h-[50px] items-center justify-center rounded-[9px] border border-white/10 px-7 text-[10px] font-black uppercase tracking-[0.14em] text-white transition hover:border-[#ffcc66]/30 hover:text-[#ffcc66]"
                >
                  Back To Home
                </Link>

              </div>

            </div>

          </section>

        </main>

        {/* =================================================
            RIGHT SIDEBAR
        ================================================= */}

        <aside className="hidden border-l border-white/[0.07] xl:block">

          <div className="sticky top-[76px] px-5 py-8">

            <div className="text-[11px] font-black text-white">
              On this page
            </div>

            <div className="mt-4 space-y-1">

              {sections.slice(
                0,
                8
              ).map(
                (section) => {
                  const active =
                    activeSection ===
                    section.id;

                  return (
                    <button
                      key={
                        section.id
                      }
                      type="button"
                      onClick={() =>
                        goToSection(
                          section.id
                        )
                      }
                      className={`block w-full rounded-[7px] border-l-2 px-3 py-2 text-left text-[11px] transition ${
                        active
                          ? "border-[#ffcc66] bg-[#ffcc66]/10 text-[#ffcc66]"
                          : "border-transparent text-[#777] hover:text-white"
                      }`}
                    >
                      {
                        section.label
                      }
                    </button>
                  );
                }
              )}

            </div>

          </div>

        </aside>

      </div>

    </div>
  );
}

/* =========================================================
   RULE SECTION
========================================================= */

function RuleSection({
  id,
  number,
  title,
  children,
  danger = false,
}) {
  return (
    <section
      id={id}
      className="scroll-mt-[110px] py-5"
    >

      <div className="flex items-start gap-4">

        <div
          className={`flex h-9 min-w-[36px] items-center justify-center rounded-[8px] border text-[10px] font-black ${
            danger
              ? "border-red-500/25 bg-red-500/[0.06] text-red-300"
              : "border-[#ffcc66]/20 bg-[#ffcc66]/[0.05] text-[#ffcc66]"
          }`}
        >
          {number}
        </div>

        <div className="min-w-0">

          <h2
            className={`text-xl font-black uppercase leading-7 sm:text-2xl ${
              danger
                ? "text-red-200"
                : "text-white"
            }`}
          >
            {title}
          </h2>

        </div>

      </div>

      <div className="mt-6 space-y-4 text-[15px] leading-8 text-[#999]">
        {children}
      </div>

    </section>
  );
}

/* =========================================================
   DIVIDER
========================================================= */

function Divider() {
  return (
    <div className="my-6 h-px bg-white/[0.07]" />
  );
}

/* =========================================================
   BULLETS
========================================================= */

function BulletList({
  items,
}) {
  return (
    <ul className="space-y-3">

      {items.map(
        (item) => (
          <li
            key={item}
            className="flex gap-3"
          >

            <span className="mt-[12px] h-1.5 w-1.5 shrink-0 rounded-full bg-[#ffcc66]" />

            <span>
              {item}
            </span>

          </li>
        )
      )}

    </ul>
  );
}

/* =========================================================
   EXAMPLE
========================================================= */

function ExampleBox({
  children,
}) {
  return (
    <div className="rounded-[12px] border border-white/[0.08] bg-white/[0.02] p-5 text-sm leading-7 text-[#aaa]">
      {children}
    </div>
  );
}

/* =========================================================
   TIER
========================================================= */

function TierBox({
  value,
}) {
  return (
    <div className="rounded-[10px] border border-[#ffcc66]/20 bg-[#ffcc66]/[0.04] px-4 py-4 text-center text-sm font-black text-[#ffcc66]">
      {value}
    </div>
  );
}

/* =========================================================
   STATUS
========================================================= */

function StatusBox({
  text,
  good = false,
}) {
  return (
    <div
      className={`flex min-h-[68px] items-center justify-center rounded-[11px] border px-4 py-4 text-center text-[11px] font-black uppercase tracking-[0.07em] ${
        good
          ? "border-[#ffcc66]/20 bg-[#ffcc66]/[0.05] text-[#ffcc66]"
          : "border-red-500/20 bg-red-500/[0.05] text-red-300"
      }`}
    >
      {text}
    </div>
  );
}